module.exports = __webpack_public_path__ + "img/Fond_accessoire_deco.a02b53d.jpg";